// import { loadExercisesList } from './exercises-list.js';

export function initExercisesTabs() {
  const tabsContainer = document.querySelector('.js-exercises-tabs');
  if (!tabsContainer) return;
}
